"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Coupon = exports.CouponStatusEnum = exports.CouponActionEnum = exports.CouponConditionEnum = void 0;
var account_1 = require("../account");
var CouponConditionEnum;
(function (CouponConditionEnum) {
  CouponConditionEnum[CouponConditionEnum["times"] = 1] = "times";
})(CouponConditionEnum = exports.CouponConditionEnum || (exports.CouponConditionEnum = {}));
var CouponActionEnum;
(function (CouponActionEnum) {
  /** подарок в виде кредитов */
  CouponActionEnum[CouponActionEnum["credits_gift"] = 1] = "credits_gift";
})(CouponActionEnum = exports.CouponActionEnum || (exports.CouponActionEnum = {}));
var CouponStatusEnum;
(function (CouponStatusEnum) {
  CouponStatusEnum[CouponStatusEnum["enabled"] = 1] = "enabled";
  CouponStatusEnum[CouponStatusEnum["disabled"] = 2] = "disabled";
})(CouponStatusEnum = exports.CouponStatusEnum || (exports.CouponStatusEnum = {}));
/** Промо-код или скидочный купон */
var Coupon = /** @class */function () {
  function Coupon(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = ['id', 'code', 'title', 'type', 'currency_id', 'min_purchase_amount', 'amount', 'note'];
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    instance.active_from = values.active_from instanceof Date ? values.active_from : new Date(values.active_from);
    instance.expires_at = values.expires_at instanceof Date ? values.expires_at : new Date(values.expires_at);
    instance.currency = account_1.currencies[values.currency_id];
  }
  return Coupon;
}();
exports.Coupon = Coupon;
